import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {RichText} from 'prismic-reactjs';
import {Box, Container} from '@spothero/ui/';
import {
    bodySerializer,
    headingSerializer,
    ignoreEmptyRichTextObjects,
} from 'cms/utils';
import MarketingMetas from 'common/marketing-metas';

const Legal = () => {
    const page = useSelector(state => state.page);

    return (
        <Box
            as="article"
            paddingTop={{base: 8, tablet: 16}}
            paddingBottom={{base: 8, tablet: 16}}
            backgroundColor="white"
        >
            <MarketingMetas bodyClassNames="standalone-page" />
            <Container>
                <Box marginBottom={{base: 6, tablet: 8}} textAlign="center">
                    <RichText
                        render={ignoreEmptyRichTextObjects(page.title)}
                        htmlSerializer={headingSerializer('h1')}
                    />
                </Box>
                <RichText
                    render={ignoreEmptyRichTextObjects(page.content)}
                    htmlSerializer={bodySerializer()}
                />
            </Container>
        </Box>
    );
};

Legal.propTypes = {
    page: PropTypes.shape({
        title: PropTypes.array,
        content: PropTypes.array,
    }),
};

export default Legal;
